export const getScrollPercent = () => {
	const h = document.documentElement,
		b = document.body,
		st = 'scrollTop',
		sh = 'scrollHeight';
	const calcScroll =
		( ( h[ st ] || b[ st ] ) /
			( ( h[ sh ] || b[ sh ] ) - h.clientHeight ) ) *
		100;
	return Math.round( calcScroll );
};

export const isObjectEmpty = ( objectName ) => {
	return Object.keys( objectName ).length === 0;
};

export const setDismissPopupDataOnLocalStorage = (
	localKey,
	popupId,
	intervalDuration = 0
) => {
	const isExistData = window?.localStorage?.getItem( localKey )
		? window?.localStorage?.getItem( localKey )
		: {};
	// TODO: check already data on localStorage
	const date = new Date();
	date.setTime( date.getTime() + intervalDuration * 24 * 60 * 60 * 1000 );

	if ( intervalDuration > 0 ) {
		if ( ! isObjectEmpty( isExistData ) ) {
			window?.localStorage?.setItem(
				localKey,
				JSON.stringify( [
					...JSON.parse( isExistData ),
					{
						expireDate: Date.parse( date ),
						popupId,
					},
				] )
			);

			return;
		}

		window?.localStorage?.setItem(
			localKey,
			JSON.stringify( [
				{
					expireDate: Date.parse( date ),
					popupId,
				},
			] )
		);
	}
};

export const getDismissPopupDataOnLocalStorage = ( localKey, popupId ) => {
	const isExistData = window?.localStorage?.getItem( localKey )
		? window?.localStorage?.getItem( localKey )
		: {};
	if ( ! isObjectEmpty( isExistData ) ) {
		const parseLocalData = JSON.parse( isExistData );
		const date = new Date();
		const filteredData = parseLocalData.filter(
			( popup ) => popup.popupId === popupId
		);

		if ( filteredData[ 0 ]?.expireDate > Date.parse( date ) ) {
			return true;
		}

		return false;
	}

	return null;
};

export const getFlexItemsPosition = ( position ) => {
	const alignment = {};

	switch ( position ) {
		case 'top-left':
			alignment.alignItems = 'flex-start';
			alignment.justifyContent = 'flex-start';
			break;

		case 'top-center':
			alignment.alignItems = 'flex-start';
			alignment.justifyContent = 'center';
			break;
		case 'top-right':
			alignment.alignItems = 'flex-start';
			alignment.justifyContent = 'flex-end';
			break;
		case 'center-left':
			alignment.alignItems = 'center';
			alignment.justifyContent = 'flex-start';
			break;
		case 'center':
			alignment.alignItems = 'center';
			alignment.justifyContent = 'center';
			break;
		case 'center-right':
			alignment.alignItems = 'center';
			alignment.justifyContent = 'flex-end';
			break;
		case 'bottom-left':
			alignment.alignItems = 'flex-end';
			alignment.justifyContent = 'flex-start';
			break;
		case 'bottom-center':
			alignment.alignItems = 'flex-end';
			alignment.justifyContent = 'center';
			break;
		case 'bottom-right':
			alignment.alignItems = 'flex-end';
			alignment.justifyContent = 'flex-end';
			break;

		default:
			break;
	}
	return alignment;
};

export const getCurrentPostOrPageId = ( pageIds ) => {
	const body = document.querySelector( 'body' );
	const getBodyClass = body?.getAttribute( 'class' );
	const splitBodyClass = getBodyClass?.split( ' ' );
	let id;

	pageIds?.forEach( ( pageId ) => {
		const searchId = `page-id-${ pageId }`;
		if ( splitBodyClass?.includes( searchId ) ) {
			id = searchId;
		}
	} );

	return id ? true : false;
};
